module.exports = __webpack_public_path__ + "static/emoterW-2e193cea70b0f8902415697f20ec5ea4.png";